import { css, keyframes } from '@emotion/core'

const shimmer = keyframes`
  0% {
    opacity: 0.45;
  }

  50% {
    opacity: 0.8;
  }

  100% {
    opacity: 0.45;
  }
`

export const wrapper = css`
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 18px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.02);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18);

  .rt-table {
    border-bottom: none;
    background: transparent;
  }

  .rt-thead.-header {
    position: sticky;
    top: 0;
    z-index: 2;
    background: rgba(36, 36, 36, 0.96);
    backdrop-filter: blur(8px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  .rt-th {
    padding: 14px 16px;
    color: rgba(255, 255, 255, 0.86);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .rt-th.inwin-table__header--primary,
  .rt-td.inwin-table__cell--primary {
    color: rgba(255, 255, 255, 0.98);
  }

  .rt-th.inwin-table__header--action,
  .rt-td.inwin-table__cell--action {
    justify-content: flex-end;
    text-align: right;
  }

  .rt-tr-group {
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  }

  .rt-tr-group:nth-of-type(even) {
    background: rgba(255, 255, 255, 0.015);
  }

  .rt-td {
    display: flex;
    align-items: center;
    padding: 14px 16px;
    color: rgba(255, 255, 255, 0.9);
  }

  .-pagination {
    background: rgba(22, 22, 22, 0.94);
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.86);
  }

  .pagination-only {
    .rt-table {
      display: none;
    }
  }
`

export const stateWrapper = css`
  display: flex;
  min-height: 240px;
  padding: 32px 24px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(255, 255, 255, 0.02);
  text-align: center;
`

export const skeletonWrapper = css`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 18px 16px 20px;
`

export const skeletonRow = (columnCount) => css`
  display: grid;
  grid-template-columns: repeat(${columnCount}, minmax(0, 1fr));
  gap: 12px;
`

export const skeletonCell = css`
  height: 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  animation: ${shimmer} 1.4s ease-in-out infinite;
`

export const skeletonCellPrimary = css`
  height: 20px;
  background: rgba(255, 255, 255, 0.14);
`
